import { Routes } from '@angular/router';
import { AdminPageComponent } from './pages/admin-page/admin-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { UserPageComponent } from './pages/user-page/user-page.component';
import { AdminGuard } from './shared/guards/admin.guard';
import { UserGuard } from './shared/guards/user.guard';

export const APPLICATION_ROUTES: Routes = [
  {
    path: 'login',
    loadComponent: () => LoginPageComponent,
  },

  {
    path: 'admin-page',
    loadComponent: () => AdminPageComponent,
    canActivate: [AdminGuard()],
  },

  {
    path: 'user-page',
    loadComponent: () => UserPageComponent,
    canActivate: [UserGuard()],
  },

  {
    path: '**',
    redirectTo: 'sign-in',
  },
];
